/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ex_TitleInputs */

const en_to_yaml_ex_title = /** @type {(inputs: To_Yaml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting a config object`)
};

const ko_to_yaml_ex_title = /** @type {(inputs: To_Yaml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정 객체 변환하기`)
};

const ja_to_yaml_ex_title = /** @type {(inputs: To_Yaml_Ex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定オブジェクトを変換する`)
};

/**
* | output |
* | --- |
* | "Converting a config object" |
*
* @param {To_Yaml_Ex_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ex_title = /** @type {((inputs?: To_Yaml_Ex_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ex_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ex_title(inputs)
	if (locale === "ko") return ko_to_yaml_ex_title(inputs)
	return ja_to_yaml_ex_title(inputs)
});